import {Component, OnInit} from '@angular/core';
import {EventTrackerService} from '../../services/event-tracker/event-tracker.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonService} from '../../services/common/common.service';
import {AuthService} from '../../core/auth.service';
import {UserService} from '../../services/user.service';
import {ReturnUrlRoute} from '../login/login.component';
import {UserType} from '../../../models/user';
import {TranslateService} from '@ngx-translate/core';
import {CommonConstant} from '../../app.constants';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';

@Component({
  selector: 'sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {

  public signUpSuccess = false;
  public isInvited = false;

  constructor(private eventTracker: EventTrackerService,
              private userService: UserService,
              private commonService: CommonService,
              private placeholderService: PlaceholderVisibilityService,
              private route: ActivatedRoute,
              private router: Router,
              private auth: AuthService) {
    this.signUpSuccess = this.route.snapshot.data['isSuccess'];
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.commonService.storeUTMData(params.utm_source, params.utm_campaign, params.utm_medium);
    });
  }

  afterSignUpSuccess(evt) {
    this.isInvited = evt.invited;
    this.auth.saveAuthTokenInLocal(evt.userData.Authorization, evt.userData.email);
    this.callFbPixelToTrackSignUpEvent();
    this.getCurrentUser();
    this.commonService.clearUTMData();
  }

  private getCurrentUser() {
    this.auth.getUserData(user => {
      this.eventTracker.trackUserSignup(this.auth.getUser(), this.isInvited);
      let returnUrl = ReturnUrlRoute.DISCOVER;
      if (this.auth.getUser().type === UserType.ANALYST) {
        returnUrl = ReturnUrlRoute.ADMIN;
      }
      if (!this.userService.getCompanyId()) {
        this.userService.loadAccountListByUser(this.auth.getUser(), () => {
          this.navigateToAuthPage(returnUrl);
        });
      } else {
        this.navigateToAuthPage(returnUrl);
      }
    }, err => {
      this.auth.logout();
    });
  }

  private navigateToAuthPage(returnUrl) {
    this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
    this.router.navigate([`/${returnUrl}`]);
  }

  private callFbPixelToTrackSignUpEvent() {
    if (typeof (<any>window).fbq !== 'undefined') {
      console.log('fbq is ready to call');
      (<any> window).fbq('track', 'CompleteRegistration');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/sign-up/sign-up.component.ts